"use strict";
// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebSocketEvents = exports.WebSocketClient = exports.DEFAULT_LIMIT_BEFORE = exports.DEFAULT_LIMIT_AFTER = exports.ClientError = exports.Client4 = void 0;
var client4_1 = require("./client4");
Object.defineProperty(exports, "Client4", { enumerable: true, get: function () { return __importDefault(client4_1).default; } });
Object.defineProperty(exports, "ClientError", { enumerable: true, get: function () { return client4_1.ClientError; } });
Object.defineProperty(exports, "DEFAULT_LIMIT_AFTER", { enumerable: true, get: function () { return client4_1.DEFAULT_LIMIT_AFTER; } });
Object.defineProperty(exports, "DEFAULT_LIMIT_BEFORE", { enumerable: true, get: function () { return client4_1.DEFAULT_LIMIT_BEFORE; } });
var websocket_1 = require("./websocket");
Object.defineProperty(exports, "WebSocketClient", { enumerable: true, get: function () { return __importDefault(websocket_1).default; } });
var websocket_events_1 = require("./websocket_events");
Object.defineProperty(exports, "WebSocketEvents", { enumerable: true, get: function () { return websocket_events_1.WebSocketEvents; } });
